import { Avatar as MuiAvatar } from '@material-ui/core';

export const Avatar = ({ record }) => {
  const fullName = record.full_name
    .split(' ')
    .filter((_, i) => i < 2);
  return (
    <MuiAvatar src={record.photo}>
      {fullName.map(el => {
        return el.charAt(0);
      })}
    </MuiAvatar>
  );
};